"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API = void 0;
/**
 * API types for NextGammon
 * Contains request and response types for all API endpoints
 */
var API;
(function (API) {
    // Game
    var Game;
    (function (Game) {
        var SSEEventType;
        (function (SSEEventType) {
            SSEEventType["GAME_DETAILS"] = "game-details";
            SSEEventType["GAME_UPDATE"] = "game-update";
            SSEEventType["HEARTBEAT"] = "heartbeat";
            SSEEventType["GAME_END"] = "game-end";
            SSEEventType["MATCHMAKING_WAITING"] = "matchmaking-waiting";
            SSEEventType["MATCHMAKING_MATCH_FOUND"] = "matchmaking-match-found";
            SSEEventType["DOUBLE_OFFERED"] = "double-offered";
            SSEEventType["DOUBLE_ACCEPTED"] = "double-accepted";
            SSEEventType["DOUBLE_DECLINED"] = "double-declined";
            SSEEventType["EMOTE_SENT"] = "emote-sent";
        })(SSEEventType = Game.SSEEventType || (Game.SSEEventType = {}));
    })(Game = API.Game || (API.Game = {}));
})(API || (exports.API = API = {}));
//# sourceMappingURL=api.js.map